module.exports = __webpack_public_path__ + "static/IMG_0028-f0937e5a0f3b26cc4d4227c5472941b5.jpg";